module.exports = __webpack_public_path__ + "img/water-green-outer-corner.626704dc.png";